{
  "logout": "Logout",
  "enter": "Enter {{placeholder}}",
  "email": "Email",
  "cellphone": "Phone Number",
  "role": "Role",
  "jobTitle": "Job Title",
  "districtAdmin": "District Admin",
  "firstName": "First Name",
  "lastName": "Last Name",
  "campus": "Campus",
  "district": "District",
  "name": "Name",
  "somethingWentWrong": "Something went wrong",
  "campusGuardianAngel": "Campus Guardian Angel",
  "customizedTable": "customized table",
  "noPhoneOnFile": "No phone on file",
  "addTag": "Add Tag",
  "n404PageNotFound": "404 - Page Not Found",
  "sorryPageLookingCouldNot": "Sorry, the page you are looking for could not be found.",
  "goBackHome": "Go Back Home",
  "general": "General",
  "details": "Details",
  "editUserDetails": "Edit User Details",
  "save": "Save",
  "location": "Location",
  "add": "Add",
  "saveChanges": "Save Changes",
  "campusName": "Campus Name",
  "pointsOfContact": "Points of Contact",
  "delete": "Delete",
  "user": "User",
  "noData": "No Data",
  "clearSearch": "Clear Search",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "permissionHasBeenUpdated": "Permission has been updated",
  "previous": "Previous",
  "next": "Next",
  "noneTheseIconsWorksTag": "None of these icons works for you tag? Contact us and we’ll design a new one just for you and your use case!",
  "icon": "icon",
  "clear": "Clear",
  "userAvatar": "User avatar",
  "refresh": "Refresh",
  "no": "No",
  "yes": "Yes",
  "error": "Error",
  "ok": "Ok",
  "info": "Info",
  "search": "Search",
  "lawEnforcement": "Law Enforcement",
  "users": "Users",
  "campuses": "Campuses",
  "buildings": "Buildings",
  "staff": "Staff",
  "n911Dispatcher": "911 Dispatcher",
  "notes": "Notes",
  "status": "Status",
  "source": "Source",
  "createdAt": "Created At",
  "tags": "Tags",
  "students": "Students",
  "lawEnforcements": "Law Enforcements",
  "911Dispatchers": "911 Dispatchers",
  "address": "Address",
  "active": "Active",
  "archived": "Archived",
  "invite": "Invite",
  "continue": "Continue",
  "copied": "Copied",
  "goBack": "Go Back",
  "resendIn": "Resend in",
  "resend": "Resend",
  "aNewEmailOtpHas": "A new email OTP has been sent.",
  "aNewPhoneOtpHas": "A new phone OTP has been sent.",
  "newOtpsHaveBeenSent": "New OTPs have been sent to both email and phone.",
  "youHaveUnsavedChangesAre": "You have unsaved changes. Are you sure you want to leave?",
  "itemDeleted": "{{name}} deleted successfully",
  "itemArchived": "{{name}} archived successfully",
  "itemActivated": "{{name}} activated successfully",
  "close": "Close",
  "copy": "Copy",
  "rowItemNames": {
    "ExternalAdmin": "Admin",
    "Tags": "Tag",
    "districts": "District",
    "building": "Building",
    "campus": "Campus",
    "domain": "Domain",
    "domainUser": "User",
    "domainLE": "User",
    "incidents": "Incident",
    "ongoingIncident": "Incident",
    "Staff": "Staff member",
    "Student": "Student",
    "Law Enforcement": "Law Enforcement user"
  },
  "selectItem": "Select {{item}}",
  "selectAllRows": "Select all rows",
  "skipForNow": "Skip for Now",
  "loading": "Loading",
  "loadingPage": "Loading page",
  "meSuffix": "(Me)",
  "districtAdminSuffix": "(District Admin)",
  "justNow": "just now",
  "minutesAgo_one": "{{count}} minute ago",
  "minutesAgo_other": "{{count}} minutes ago",
  "hoursAgo_one": "{{count}} hour ago",
  "hoursAgo_other": "{{count}} hours ago",
  "daysAgo_one": "{{count}} day ago",
  "daysAgo_other": "{{count}} days ago",
  "weeksAgo_one": "{{count}} week ago",
  "weeksAgo_other": "{{count}} weeks ago",
  "monthsAgo_one": "{{count}} month ago",
  "monthsAgo_other": "{{count}} months ago",
  "yearsAgo_one": "{{count}} year ago",
  "yearsAgo_other": "{{count}} years ago",
  "iconNumber": "Icon {{number}}",
  "noOptions": "No options available"
}
